import { useEffect } from 'react';
import PageHeader from '../../components/PageHeader';
import { Atom } from '../../components/Icons';
import { RESEARCH_MEDICAL } from '../../config/data';
import { t } from '../../utils/i18n';
import './index.css';

const GROUPS = [
    { id: 'matrix', eyebrow: 'Foundation Models', title: t('大模型矩阵', 'Foundation Models'), cols: 2 },
    { id: 'agent', eyebrow: 'Product', title: t('AI Agent 产品', 'AI Agent Products'), cols: 1 },
    { id: 'framework', eyebrow: 'Framework', title: t('智能体框架', 'Agent Framework'), cols: 1 },
];

export default function MedicalAIPage() {
    useEffect(() => {
        document.title = t('医疗智能 · 至知创新研究院', 'Medical AI · IQuest Research');
    }, []);

    const byGroup = GROUPS.map((g) => ({
        ...g,
        items: RESEARCH_MEDICAL.filter((it) => it.group === g.id),
    })).filter((g) => g.items.length > 0);

    return (
        <div className="page-shell">
            <PageHeader
                eyebrow={t('医疗智能 · Medical AI', 'Medical AI')}
                title={t('可解释、可循证、可信赖的医学智能', 'Medical AI: Explainable · Evidence‑Based · Trustworthy')}
                subtitle={t(
                    '以推理、视觉理解与循证应用为核心，构建覆盖医学语言、多模态与助手产品的系统化能力矩阵。',
                    'Centered on reasoning, visual understanding, and evidence‑based practice, we build systematic capability that spans medical language, multimodal, and assistant products.'
                )}
            />
            {byGroup.map((g) => (
                <section className="section medical-group-section" key={g.id}>
                    <div className="container">
                        <div className="medical-group-header">
                            <div className="eyebrow">{g.eyebrow}</div>
                            <h2 className="section-title">{g.title}</h2>
                        </div>
                        <div className={`product-grid product-grid-${g.cols}`}>
                            {g.items.map((item, idx) => {
                                const isFramework = g.id === 'framework';
                                return (
                                    <article className="product-card" key={item.id ?? idx}>
                                        <div className="product-card-img">
                                            <img
                                                src={item.img}
                                                alt={item.title}
                                                loading={isFramework ? 'eager' : 'lazy'}
                                                decoding="async"
                                            />
                                            {isFramework && (
                                                <span className="product-card-img-fallback" aria-hidden>
                                                    <Atom width={120} height={120} />
                                                </span>
                                            )}
                                        </div>
                                        <div className="product-card-body">
                                            <div className="product-card-title">{item.title}</div>
                                            <p className="product-card-desc">{item.desc}</p>
                                        </div>
                                    </article>
                                );
                            })}
                        </div>
                    </div>
                </section>
            ))}
        </div>
    );
}
